export default "__VITE_PUBLIC_ASSET__74a5442d__"